module.exports = __webpack_public_path__ + "static/img/noData.6300713d.png";